// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"72":"caed75b3240d0a75","140":"150f5467a0d0fe60","239":"44fcb5e1a71cec95","863":"fd25f54b9b0f4a25","991":"94c640e2b1477997"}[chunkId] + ".js";
};